import React, { useRef, useState } from "react";
import CustomDatePicker from "../../components/CustomDatePicker";
import MyAccountFilter from "../MyAccount/MyAccountFilter";
import moment from "moment";

const ReportByBoCasino = () => {
  const tableRef = useRef();
  const [tab, setTab] = useState("casinoGame");
  const [filter, setFilter] = useState({
    from: moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss"),
    to: moment().format("YYYY-MM-DD HH:mm:ss"),
  });
  return (
    <app-pl-awccasino _nghost-serverapp-c116 className="ng-star-inserted">
      <div _ngcontent-serverapp-c116 className="main_wrap">
        <div _ngcontent-serverapp-c116 className="box">
          <h2 _ngcontent-serverapp-c116>Profit/Loss Report by BO Casino</h2>
        </div>
        <ul className="report-tab-wrap">
          <li
            id="reportType_exchange"
            data-reporttabtype={0}
            className={`report-tab ${tab === "casino" ? "select" : ""}`}
            onClick={() => setTab("casino")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              Casino
            </a>
          </li>

          <li
            id="reportType_sportsBook"
            data-reporttabtype={2}
            className={`report-tab ${tab === "casinoGame" ? "select" : ""}`}
            onClick={() => setTab("casinoGame")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              Casino Game Pnl
            </a>
          </li>

          <li
            className={`report-tab ${tab === "playerPnl" ? "select" : ""}`}
            tabIndex={0}
            onClick={() => setTab("playerPnl")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              Player P/L
            </a>
          </li>
        </ul>
        <div _ngcontent-serverapp-c116 className="function-wrap">
          <ul _ngcontent-serverapp-c116 className="input-list flowroot">
            <div
              _ngcontent-serverapp-c116
              id="statusCondition"
              style={{ display: "none" }}
            >
              <li _ngcontent-serverapp-c116>
                <label _ngcontent-serverapp-c116>Bet Status:</label>
              </li>
              <li _ngcontent-serverapp-c116>
                <select
                  _ngcontent-serverapp-c116
                  name="betStatus"
                  id="betStatus"
                />
              </li>
            </div>
            <li _ngcontent-serverapp-c116 />
            <li _ngcontent-serverapp-c116>
              <label _ngcontent-serverapp-c116>Period</label>
            </li>
            <CustomDatePicker filter={filter} setFilter={setFilter} />
            <li _ngcontent-serverapp-c116 style={{ display: "none" }}>
              (Timezone:IST)
            </li>
            <li _ngcontent-serverapp-c116 className="ng-star-inserted">
              <label _ngcontent-serverapp-c116>User List:</label>
              <ng-select
                _ngcontent-serverapp-c116
                name="sortCondition"
                id="sortCondition"
                className="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-untouched ng-pristine ng-valid"
              >
                <div className="ng-select-container ng-has-value">
                  <div className="ng-value-container">
                    <div className="ng-placeholder" />
                    <div className="ng-value ng-star-inserted">
                      {/**/}
                      <span
                        aria-hidden="true"
                        className="ng-value-icon left ng-star-inserted"
                      >
                        ×
                      </span>
                      <span className="ng-value-label ng-star-inserted">
                        Select User{" "}
                      </span>
                      {/**/}
                    </div>
                    {/**/}
                    {/**/}
                    {/**/}
                    {/**/}
                    <div
                      role="combobox"
                      aria-haspopup="listbox"
                      className="ng-input"
                      aria-expanded="false"
                    >
                      <input
                        aria-autocomplete="list"
                        type="text"
                        autoCorrect="off"
                        autoCapitalize="off"
                        autoComplete="ad05b582d718"
                      />
                    </div>
                  </div>
                  {/**/}
                  <span
                    className="ng-clear-wrapper ng-star-inserted"
                    title="Clear all"
                  >
                    <span aria-hidden="true" className="ng-clear">
                      ×
                    </span>
                  </span>
                  {/**/}
                  <span className="ng-arrow-wrapper">
                    <span className="ng-arrow" />
                  </span>
                </div>
                {/**/}
              </ng-select>
            </li>
            {/**/}
          </ul>
          <ul _ngcontent-serverapp-c116 className="input-list flowroot">
            <li _ngcontent-serverapp-c116>
              <a _ngcontent-serverapp-c116 id="today" className="btn">
                Just for today
              </a>
            </li>
            <li _ngcontent-serverapp-c116>
              <a _ngcontent-serverapp-c116 id="yesterday" className="btn">
                From yesterday
              </a>
            </li>
            <li _ngcontent-serverapp-c116 style={{ display: "none" }}>
              <a
                _ngcontent-serverapp-c116
                id="last7days"
                href="#"
                className="btn"
              >
                Last 7 days
              </a>
            </li>
            <li _ngcontent-serverapp-c116 style={{ display: "none" }}>
              <a
                _ngcontent-serverapp-c116
                id="last30days"
                href="#"
                className="btn"
              >
                Last 30 days
              </a>
            </li>
            <li _ngcontent-serverapp-c116 style={{ display: "none" }}>
              <a
                _ngcontent-serverapp-c116
                id="last2months"
                href="#"
                className="btn"
              >
                {" "}
                Last 2 Months
              </a>
            </li>
            <li _ngcontent-serverapp-c116 style={{ display: "none" }}>
              <a
                _ngcontent-serverapp-c116
                id="last3months"
                href="#"
                className="btn"
              >
                {" "}
                Last 3 Months
              </a>
            </li>
            <li _ngcontent-serverapp-c116>
              <a _ngcontent-serverapp-c116 id="getPL" className="btn-send">
                {" "}
                Get P &amp; L
              </a>
            </li>
          </ul>
        </div>
        <div _ngcontent-serverapp-c116 id="noReportMessage" />
        <div _ngcontent-serverapp-c116 id="userTreeDiv" className="total_all">
          <ul _ngcontent-serverapp-c116 style={{ display: "none" }}>
            <li _ngcontent-serverapp-c116 id="tempTree">
              <a _ngcontent-serverapp-c116>
                <span _ngcontent-serverapp-c116 className="lv_1" />
              </a>
            </li>
            <li
              _ngcontent-serverapp-c116
              id="tempCurrencyTree"
              className="currency_tag"
            >
              <strong _ngcontent-serverapp-c116 />
            </li>
          </ul>
          <div _ngcontent-serverapp-c116 id="treePath" className="agent_path" />
          <div
            _ngcontent-serverapp-c116
            id="expandAllDiv"
            style={{ display: "none" }}
          >
            <a _ngcontent-serverapp-c116 id="showDetail" className="btn_expand">
              Expand All
            </a>
          </div>
          <span _ngcontent-serverapp-c116>
            <label _ngcontent-serverapp-c116>Last:</label>
            <select _ngcontent-serverapp-c116 name="limit" id="limit">
              <option _ngcontent-serverapp-c116 value={100}>
                100 Txn
              </option>
              <option _ngcontent-serverapp-c116 value={50}>
                50 Txn
              </option>
              <option _ngcontent-serverapp-c116 value={25} selected>
                25 Txn
              </option>
              <option _ngcontent-serverapp-c116 value={10}>
                10 Txn
              </option>
              <option _ngcontent-serverapp-c116 value="downline.length">
                Full{" "}
              </option>
            </select>
          </span>
          <span _ngcontent-serverapp-c116 className="spacer" />
          {/**/}
          <span
            _ngcontent-serverapp-c116
            className="total-users ng-star-inserted"
            style={{ "font-weight": "600" }}
          >
            Total Records: 0{" "}
          </span>
          {/**/}
          <MyAccountFilter
            type={"new"}
            tableRef={tableRef}
            fileName="report-AWC-casino"
          />
        </div>
        {tab == "casinoGame" && (
          <div
            _ngcontent-serverapp-c121
            className="over-wrap"
            style={{ "max-height": "calc(100% - 32px - 93px - 55px)" }}
          >
            <div
              _ngcontent-serverapp-c121
              className="table-responsive data-table"
            >
              <div _ngcontent-serverapp-c121 id="report">
                <table
                  ref={tableRef}
                  _ngcontent-serverapp-c121
                  id="table_DL"
                  className="table-s"
                  style={{ display: "table" }}
                >
                  <tbody _ngcontent-serverapp-c121>
                    <tr _ngcontent-serverapp-c121>
                      <th
                        _ngcontent-serverapp-c121
                        id="betTime"
                        width="6%"
                        data-name="userName"
                        className="align-L"
                      >
                        {" "}
                        SportName{" "}
                      </th>
                      <th
                        _ngcontent-serverapp-c121
                        width="5%"
                        data-order="asc"
                        data-name="totalPNL"
                        className="sort_asc"
                      >
                        Total Profit/loss
                      </th>
                      <th
                        _ngcontent-serverapp-c121
                        width="5%"
                        data-order="asc"
                        data-name="totalStake"
                        className="sort_asc"
                      >
                        Total Stake{" "}
                      </th>
                    </tr>
                    <tr _ngcontent-serverapp-c121>
                      <td _ngcontent-serverapp-c121 className="align-L">
                        <a
                          _ngcontent-serverapp-c121
                          className="expand-open"
                          style={{ width: "15px" }}
                        />
                        <a href="#" _ngcontent-serverapp-c121>
                          <span _ngcontent-serverapp-c121 className="sprtcls">
                            SEXYBCRT
                          </span>
                        </a>
                      </td>
                      <td _ngcontent-serverapp-c121 className="align-r">
                        {/**/}
                        <div _ngcontent-serverapp-c121>
                          <span _ngcontent-serverapp-c121 className="loss-text">
                            {" "}
                            (10.00){" "}
                          </span>
                          {/**/}
                          {/**/}
                        </div>
                        {/**/}
                      </td>
                      <td _ngcontent-serverapp-c121 className="align-r">
                        {" "}
                        10.00
                      </td>
                    </tr>
                    <tr
                      _ngcontent-serverapp-c121
                      className="expand"
                      style={{ display: "table-row" }}
                      id="sub_0"
                    >
                      <td _ngcontent-serverapp-c121 colSpan={5}>
                        <img
                          _ngcontent-serverapp-c121
                          src="/assets/images/transparent.gif"
                          className="expand-arrow-R"
                        />
                        <table
                          // style={{ marginLeft: "25%" }}
                          _ngcontent-serverapp-c121
                          className="table-commission"
                        >
                          <tbody _ngcontent-serverapp-c121>
                            <tr _ngcontent-serverapp-c121>
                              <th
                                _ngcontent-serverapp-c121
                                width="20%"
                                className="align-L"
                              >
                                GameName
                              </th>
                              <th
                                _ngcontent-serverapp-c121
                                width="15%"
                                className="align-L"
                              >
                                Game Type
                              </th>
                              <th _ngcontent-serverapp-c121 width="12%">
                                Total Profit/loss
                              </th>
                              <th _ngcontent-serverapp-c121 width="23%">
                                Total Stake
                              </th>
                            </tr>
                            <tr _ngcontent-serverapp-c121 className="even">
                              <td _ngcontent-serverapp-c121 className="align-L">
                                <a
                                  _ngcontent-serverapp-c121
                                  className="expand-open"
                                  style={{
                                    width: "15px",
                                    display: "inline-block",
                                  }}
                                />
                                {/**/}
                                <span
                                  _ngcontent-serverapp-c121
                                  id="_eventType"
                                  className="sprtcls"
                                >
                                  Baccarat Classic
                                </span>
                              </td>
                              <td _ngcontent-serverapp-c121 className="align-L">
                                <span
                                  _ngcontent-serverapp-c121
                                  className="game-type"
                                >
                                  LIVE
                                </span>
                                <span
                                  _ngcontent-serverapp-c121
                                  style={{
                                    "margin-left": "4px",
                                    opacity: "0.7",
                                  }}
                                >
                                  {" "}
                                  (
                                  <svg
                                    _ngcontent-serverapp-c121
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 640"
                                    style={{
                                      width: "11px",
                                      height: "11px",
                                      "vertical-align": "middle",
                                    }}
                                  >
                                    <path
                                      _ngcontent-serverapp-c121
                                      fill="rgb(0, 0, 0)"
                                      d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z"
                                    />
                                  </svg>{" "}
                                  1)
                                </span>
                                {/**/}
                              </td>
                              <td _ngcontent-serverapp-c121 id="totalPNL">
                                {/**/}
                                <div _ngcontent-serverapp-c121>
                                  <span
                                    _ngcontent-serverapp-c121
                                    className="loss-text"
                                  >
                                    {" "}
                                    (10.00){" "}
                                  </span>
                                  {/**/}
                                  {/**/}
                                </div>
                                {/**/}
                              </td>
                              <td _ngcontent-serverapp-c121 id="txLiability">
                                {" "}
                                10.00{" "}
                              </td>
                            </tr>
                            <tr
                              _ngcontent-serverapp-c121
                              className="expand"
                              style={{ display: "table-row" }}
                              id="userlist_0_0"
                            >
                              <td
                                _ngcontent-serverapp-c121
                                colSpan={4}
                                style={{ padding: "8px 0 8px 10px" }}
                              >
                                <table
                                  _ngcontent-serverapp-c121
                                  className="table-commission"
                                  style={{ "margin-left": "25% !important" }}
                                >
                                  <tbody _ngcontent-serverapp-c121>
                                    <tr _ngcontent-serverapp-c121>
                                      <th
                                        _ngcontent-serverapp-c121
                                        width="5%"
                                        data-order="desc"
                                        data-name="userName"
                                        className="align-L sort_asc"
                                        style={{
                                          "padding-left": "3rem",
                                          cursor: "pointer",
                                        }}
                                      >
                                        User Name
                                      </th>
                                      <th
                                        _ngcontent-serverapp-c121
                                        width="2%"
                                        data-order="desc"
                                        data-name="totalPNL"
                                        className="sort_asc"
                                        style={{ cursor: "pointer" }}
                                      >
                                        Total Profit/loss
                                      </th>
                                      <th
                                        _ngcontent-serverapp-c121
                                        width="9%"
                                        data-order="desc"
                                        data-name="totalStake"
                                        className="sort_asc"
                                        style={{ cursor: "pointer" }}
                                      >
                                        Total Stake
                                      </th>
                                    </tr>
                                    <tr
                                      _ngcontent-serverapp-c121
                                      className="even"
                                    >
                                      <td
                                        _ngcontent-serverapp-c121
                                        className="align-L"
                                        style={{ "padding-left": "3rem" }}
                                      >
                                        user21
                                      </td>
                                      <td _ngcontent-serverapp-c121>
                                        <span
                                          _ngcontent-serverapp-c121
                                          className="loss-text"
                                        >
                                          {" "}
                                          -10.00{" "}
                                        </span>
                                        {/**/}
                                        {/**/}
                                      </td>
                                      <td _ngcontent-serverapp-c121>10.00</td>
                                    </tr>
                                    {/**/}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            {/**/}
                            <tr
                              _ngcontent-serverapp-c121
                              className="expand"
                              style={{ display: "none" }}
                              id="sub1_0"
                            >
                              <td _ngcontent-serverapp-c121 colSpan={5}>
                                <img
                                  _ngcontent-serverapp-c121
                                  src="/assets/images/transparent.gif"
                                  className="expand-arrow-R"
                                />
                                <table
                                  _ngcontent-serverapp-c121
                                  className="table-commission"
                                >
                                  <tbody _ngcontent-serverapp-c121>
                                    <tr _ngcontent-serverapp-c121>
                                      <th
                                        _ngcontent-serverapp-c121
                                        width="13%"
                                        className="align-L"
                                      >
                                        MarketName
                                      </th>
                                      <th _ngcontent-serverapp-c121 width="12%">
                                        Total Profit/loss
                                      </th>
                                      <th _ngcontent-serverapp-c121 width="23%">
                                        Total Stake
                                      </th>
                                    </tr>
                                    {/**/}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            {/**/}
                            {/**/}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    {/**/}
                    <tr _ngcontent-serverapp-c121>
                      <td _ngcontent-serverapp-c121 className="align-L">
                        <a
                          _ngcontent-serverapp-c121
                          className="expand-close"
                          style={{ width: "15px" }}
                        />
                        <a href="#" _ngcontent-serverapp-c121>
                          <span _ngcontent-serverapp-c121 className="sprtcls">
                            KINGMAKER
                          </span>
                        </a>
                      </td>
                      <td _ngcontent-serverapp-c121 className="align-r">
                        {/**/}
                        <div _ngcontent-serverapp-c121>
                          <span _ngcontent-serverapp-c121 className="loss-text">
                            {" "}
                            (16.00){" "}
                          </span>
                          {/**/}
                          {/**/}
                        </div>
                        {/**/}
                      </td>
                      <td _ngcontent-serverapp-c121 className="align-r">
                        {" "}
                        19.00
                      </td>
                    </tr>
                    <tr
                      _ngcontent-serverapp-c121
                      className="expand"
                      style={{ display: "none" }}
                      id="sub_1"
                    >
                      <td _ngcontent-serverapp-c121 colSpan={5}>
                        <img
                          _ngcontent-serverapp-c121
                          src="/assets/images/transparent.gif"
                          className="expand-arrow-R"
                        />
                        <table
                          _ngcontent-serverapp-c121
                          className="table-commission"
                        >
                          <tbody _ngcontent-serverapp-c121>
                            <tr _ngcontent-serverapp-c121>
                              <th
                                _ngcontent-serverapp-c121
                                width="20%"
                                className="align-L"
                              >
                                GameName
                              </th>
                              <th
                                _ngcontent-serverapp-c121
                                width="15%"
                                className="align-L"
                              >
                                Game Type
                              </th>
                              <th _ngcontent-serverapp-c121 width="12%">
                                Total Profit/loss
                              </th>
                              <th _ngcontent-serverapp-c121 width="23%">
                                Total Stake
                              </th>
                            </tr>
                            <tr _ngcontent-serverapp-c121 className="even">
                              <td _ngcontent-serverapp-c121 className="align-L">
                                <a
                                  _ngcontent-serverapp-c121
                                  className="expand-close"
                                  style={{
                                    width: "15px",
                                    display: "inline-block",
                                  }}
                                />
                                {/**/}
                                <span
                                  _ngcontent-serverapp-c121
                                  id="_eventType"
                                  className="sprtcls"
                                >
                                  Coin Pusher
                                </span>
                              </td>
                              <td _ngcontent-serverapp-c121 className="align-L">
                                <span
                                  _ngcontent-serverapp-c121
                                  className="game-type"
                                >
                                  TABLE
                                </span>
                                <span
                                  _ngcontent-serverapp-c121
                                  style={{
                                    "margin-left": "4px",
                                    opacity: "0.7",
                                  }}
                                >
                                  {" "}
                                  (
                                  <svg
                                    _ngcontent-serverapp-c121
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 640"
                                    style={{
                                      width: "11px",
                                      height: "11px",
                                      "vertical-align": "middle",
                                    }}
                                  >
                                    <path
                                      _ngcontent-serverapp-c121
                                      fill="rgb(0, 0, 0)"
                                      d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z"
                                    />
                                  </svg>{" "}
                                  1)
                                </span>
                                {/**/}
                              </td>
                              <td _ngcontent-serverapp-c121 id="totalPNL">
                                {/**/}
                                <div _ngcontent-serverapp-c121>
                                  <span
                                    _ngcontent-serverapp-c121
                                    className="loss-text"
                                  >
                                    {" "}
                                    (16.00){" "}
                                  </span>
                                  {/**/}
                                  {/**/}
                                </div>
                                {/**/}
                              </td>
                              <td _ngcontent-serverapp-c121 id="txLiability">
                                {" "}
                                19.00{" "}
                              </td>
                            </tr>
                            <tr
                              _ngcontent-serverapp-c121
                              className="expand"
                              style={{ display: "none" }}
                              id="userlist_1_0"
                            >
                              <td
                                _ngcontent-serverapp-c121
                                colSpan={4}
                                style={{ padding: "8px 0 8px 10px" }}
                              >
                                <table
                                  _ngcontent-serverapp-c121
                                  className="table-commission"
                                  style={{ "margin-left": "25% !important" }}
                                >
                                  <tbody _ngcontent-serverapp-c121>
                                    <tr _ngcontent-serverapp-c121>
                                      <th
                                        _ngcontent-serverapp-c121
                                        width="5%"
                                        data-order="desc"
                                        data-name="userName"
                                        className="align-L sort_asc"
                                        style={{
                                          "padding-left": "3rem",
                                          cursor: "pointer",
                                        }}
                                      >
                                        User Name
                                      </th>
                                      <th
                                        _ngcontent-serverapp-c121
                                        width="2%"
                                        data-order="desc"
                                        data-name="totalPNL"
                                        className="sort_asc"
                                        style={{ cursor: "pointer" }}
                                      >
                                        Total Profit/loss
                                      </th>
                                      <th
                                        _ngcontent-serverapp-c121
                                        width="9%"
                                        data-order="desc"
                                        data-name="totalStake"
                                        className="sort_asc"
                                        style={{ cursor: "pointer" }}
                                      >
                                        Total Stake
                                      </th>
                                    </tr>
                                    <tr
                                      _ngcontent-serverapp-c121
                                      className="even"
                                    >
                                      <td
                                        _ngcontent-serverapp-c121
                                        className="align-L"
                                        style={{ "padding-left": "3rem" }}
                                      >
                                        user21
                                      </td>
                                      <td _ngcontent-serverapp-c121>
                                        <span
                                          _ngcontent-serverapp-c121
                                          className="loss-text"
                                        >
                                          {" "}
                                          -16.00{" "}
                                        </span>
                                        {/**/}
                                        {/**/}
                                      </td>
                                      <td _ngcontent-serverapp-c121>19.00</td>
                                    </tr>
                                    {/**/}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            {/**/}
                            <tr
                              _ngcontent-serverapp-c121
                              className="expand"
                              style={{ display: "none" }}
                              id="sub1_1"
                            >
                              <td _ngcontent-serverapp-c121 colSpan={5}>
                                <img
                                  _ngcontent-serverapp-c121
                                  src="/assets/images/transparent.gif"
                                  className="expand-arrow-R"
                                />
                                <table
                                  _ngcontent-serverapp-c121
                                  className="table-commission"
                                >
                                  <tbody _ngcontent-serverapp-c121>
                                    <tr _ngcontent-serverapp-c121>
                                      <th
                                        _ngcontent-serverapp-c121
                                        width="13%"
                                        className="align-L"
                                      >
                                        MarketName
                                      </th>
                                      <th _ngcontent-serverapp-c121 width="12%">
                                        Total Profit/loss
                                      </th>
                                      <th _ngcontent-serverapp-c121 width="23%">
                                        Total Stake
                                      </th>
                                    </tr>
                                    {/**/}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            {/**/}
                            {/**/}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    {/**/}
                    {/**/}
                    <tr _ngcontent-serverapp-c121 className="total">
                      <td _ngcontent-serverapp-c121 className="align-L">
                        Total
                      </td>
                      <td _ngcontent-serverapp-c121 className="align-R">
                        {/**/}
                        <div _ngcontent-serverapp-c121>
                          <span _ngcontent-serverapp-c121 className="loss-text">
                            {" "}
                            (26.00){" "}
                          </span>
                          {/**/}
                          {/**/}
                        </div>
                        {/**/}
                      </td>
                      <td _ngcontent-serverapp-c121 className="align-R">
                        {/**/}
                        <div _ngcontent-serverapp-c121>
                          <span _ngcontent-serverapp-c121>29.00 </span>
                          {/**/}
                          {/**/}
                        </div>
                        {/**/}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/**/}
            </div>
          </div>
        )}
        {tab == "casino" && (
          <div
            _ngcontent-serverapp-c121
            id="reportDiv"
            className="over-wrap"
            style={{ "max-height": "calc(100% - 32px - 93px - 55px)" }}
          >
            <div
              _ngcontent-serverapp-c121
              className="table-responsive data-table"
            >
              <table
                ref={tableRef}
                _ngcontent-serverapp-c121
                id="table_DL"
                className="table01 table-pt"
              >
                <tbody _ngcontent-serverapp-c121>
                  <tr _ngcontent-serverapp-c121 id="table_DL">
                    <th
                      _ngcontent-serverapp-c121
                      id="header_userName"
                      width="15%"
                      data-order="asc"
                      data-name="userName"
                      className="align-L sort_asc"
                    >
                      UID
                    </th>
                    <th
                      _ngcontent-serverapp-c121
                      width="20%"
                      data-order="asc"
                      data-name="playerPL"
                      className="sort_asc"
                    >
                      {" "}
                      Player P/L{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c121
                      id="header_profitLoss_downLine"
                      width="13%"
                      data-order="asc"
                      data-name="downLinePL"
                      className="sort_asc"
                    >
                      {" "}
                      Downline P/L{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c121
                      id="header_tax_agent_2"
                      width="10%"
                      data-order="asc"
                      data-name="commision"
                      className="sort_asc"
                    >
                      Agent Comm.
                    </th>
                    <th
                      _ngcontent-serverapp-c121
                      width="15%"
                      data-order="asc"
                      data-name="upLinePL"
                      className="sort_asc"
                    >
                      {" "}
                      Upline P/L{" "}
                    </th>
                    {/**/}
                  </tr>
                </tbody>
                <tbody _ngcontent-serverapp-c121 id="content">
                  {/**/}
                  <tr _ngcontent-serverapp-c121 id="table_DL">
                    <td _ngcontent-serverapp-c121 className="align-L">
                      <a
                        _ngcontent-serverapp-c121
                        id="_bySport"
                        className="expand-open"
                      />
                      {/**/}
                      {/**/}
                      <a
                        _ngcontent-serverapp-c121
                        id="_userName"
                        className="ico_account"
                      >
                        <span
                          _ngcontent-serverapp-c121
                          className="Bdlevel lv_5 premium"
                        />
                        subadmin21{" "}
                      </a>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_profitLoss">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121 className="loss-text">
                          {" "}
                          (-26.00){" "}
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121>
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121 className="loss-text">
                          (-26.00)
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_tax2">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121> 0.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_profitLossUpLine">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121> 26.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    {/**/}
                  </tr>
                  <tr
                    _ngcontent-serverapp-c121
                    id="table_DL"
                    className="expand expand_2"
                  >
                    <td _ngcontent-serverapp-c121 className="align-L">
                      <a
                        _ngcontent-serverapp-c121
                        id="_bySport"
                        className="expand-open"
                      />
                      {/**/}
                      {/**/}
                      <a
                        _ngcontent-serverapp-c121
                        id="_userName"
                        className="ico_account"
                      >
                        <span
                          _ngcontent-serverapp-c121
                          className="Bdlevel lv_6 premium"
                        />
                        supermaster21{" "}
                      </a>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_profitLoss">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121 className="loss-text">
                          {" "}
                          (-26.00){" "}
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121>
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121 className="loss-text">
                          (-26.00)
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_tax2">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121> 0.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_profitLossUpLine">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121> 26.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    {/**/}
                  </tr>
                  <tr
                    _ngcontent-serverapp-c121
                    id="table_DL"
                    className="expand expand_3"
                  >
                    <td _ngcontent-serverapp-c121 className="align-L">
                      <a
                        _ngcontent-serverapp-c121
                        id="_bySport"
                        className="expand-open"
                      />
                      {/**/}
                      {/**/}
                      <a
                        _ngcontent-serverapp-c121
                        id="_userName"
                        className="ico_account"
                      >
                        <span
                          _ngcontent-serverapp-c121
                          className="Bdlevel lv_7 premium"
                        />
                        master21{" "}
                      </a>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_profitLoss">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121 className="loss-text">
                          {" "}
                          (-26.00){" "}
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121>
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121 className="loss-text">
                          (-26.00)
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_tax2">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121> 0.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_profitLossUpLine">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121> 26.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    {/**/}
                  </tr>
                  <tr
                    _ngcontent-serverapp-c121
                    id="table_DL"
                    className="expand expand_4"
                  >
                    <td _ngcontent-serverapp-c121 className="align-L">
                      {/**/}
                      <a
                        _ngcontent-serverapp-c121
                        id="_userName"
                        className="ico_account"
                        href="#/users/alluser/sub/6308772/accountSummary"
                      >
                        <span
                          _ngcontent-serverapp-c121
                          className="Bdlevel lv_8 premium"
                        />
                        user21{" "}
                      </a>
                      {/**/}
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_profitLoss">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121 className="loss-text">
                          {" "}
                          (-26.00){" "}
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121>
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121>0.00</span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_tax2">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121> 0.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_profitLossUpLine">
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121> 26.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    {/**/}
                  </tr>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  <tr _ngcontent-serverapp-c121 className="total">
                    <td _ngcontent-serverapp-c121 className="align-L">
                      Total
                    </td>
                    <td _ngcontent-serverapp-c121>
                      {/**/}
                      <div _ngcontent-serverapp-c121>
                        <span _ngcontent-serverapp-c121 className="loss-text">
                          {" "}
                          (-26.00){" "}
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_totalDownlinePl">
                      <span _ngcontent-serverapp-c121 className="red">
                        {" "}
                        (-26.00){" "}
                      </span>
                      {/**/}
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_totalComm">
                      <span _ngcontent-serverapp-c121> 0.00 </span>
                      {/**/}
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c121 id="_totalUplinePL">
                      <span _ngcontent-serverapp-c121> 26.00 </span>
                      {/**/}
                      {/**/}
                    </td>
                    {/**/}
                  </tr>
                </tbody>
              </table>
            </div>
            {/**/}
          </div>
        )}

        {tab == "playerPnl" && (
          <div
            _ngcontent-serverapp-c127
            id="reportDiv"
            className="over-wrap"
            style={{ "max-height": "calc(100% - 32px - 93px - 55px)" }}
          >
            <div
              _ngcontent-serverapp-c127
              className="table-responsive data-table"
            >
              <table
                ref={tableRef}
                _ngcontent-serverapp-c127
                id="table_DL"
                className="table01 table-pt"
              >
                <tbody _ngcontent-serverapp-c127>
                  <tr _ngcontent-serverapp-c127 id="table_DL">
                    <th
                      _ngcontent-serverapp-c127
                      id="header_userName"
                      width="15%"
                      data-order="asc"
                      data-name="userName"
                      className="align-L sort_asc"
                    >
                      UID
                    </th>
                    <th
                      _ngcontent-serverapp-c127
                      width="20%"
                      data-order="asc"
                      data-name="playerPL"
                      className="sort_asc"
                    >
                      Player P/L{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c127
                      id="header_profitLoss_downLine"
                      width="13%"
                      data-order="asc"
                      data-name="downLinePL"
                      className="sort_asc"
                    >
                      {" "}
                      Downline P/L{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c127
                      id="header_tax_agent_2"
                      width="10%"
                      data-order="asc"
                      data-name="commision"
                      className="sort_asc"
                    >
                      {" "}
                      Agent Comm.
                    </th>
                    <th
                      _ngcontent-serverapp-c127
                      width="15%"
                      data-order="asc"
                      data-name="upLinePL"
                      className="sort_asc"
                    >
                      Upline P/L{" "}
                    </th>
                    {/**/}
                  </tr>
                </tbody>
                <tbody _ngcontent-serverapp-c127 id="content">
                  {/**/}
                  <tr _ngcontent-serverapp-c127 id="table_DL">
                    <td _ngcontent-serverapp-c127 className="align-L">
                      {/**/}
                      <a
                        _ngcontent-serverapp-c127
                        id="_userName"
                        className="ico_account"
                        href="#/users/alluser/sub/6308772/accountSummary"
                      >
                        <span
                          _ngcontent-serverapp-c127
                          className="Bdlevel lv_8 premium"
                        />
                        user21{" "}
                      </a>
                      {/**/}
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c127 id="_profitLoss">
                      {/**/}
                      <div _ngcontent-serverapp-c127>
                        <span _ngcontent-serverapp-c127 className="loss-text">
                          {" "}
                          (-26.00){" "}
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c127>
                      {/**/}
                      <div _ngcontent-serverapp-c127>
                        <span _ngcontent-serverapp-c127>0.00</span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c127 id="_tax2">
                      {/**/}
                      <div _ngcontent-serverapp-c127>
                        <span _ngcontent-serverapp-c127> 0.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c127 id="_profitLossUpLine">
                      {/**/}
                      <div _ngcontent-serverapp-c127>
                        <span _ngcontent-serverapp-c127> 26.00 </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    {/**/}
                  </tr>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  <tr _ngcontent-serverapp-c127 className="total">
                    <td _ngcontent-serverapp-c127 className="align-L">
                      Total
                    </td>
                    <td _ngcontent-serverapp-c127>
                      {/**/}
                      <div _ngcontent-serverapp-c127>
                        <span _ngcontent-serverapp-c127 className="loss-text">
                          {" "}
                          (-26.00){" "}
                        </span>
                        {/**/}
                        {/**/}
                      </div>
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c127 id="_totalDownlinePl">
                      <span _ngcontent-serverapp-c127> 0.00 </span>
                      {/**/}
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c127 id="_totalComm">
                      <span _ngcontent-serverapp-c127> 0.00 </span>
                      {/**/}
                      {/**/}
                    </td>
                    <td _ngcontent-serverapp-c127 id="_totalUplinePL">
                      <span _ngcontent-serverapp-c127> 26.00 </span>
                      {/**/}
                      {/**/}
                    </td>
                    {/**/}
                  </tr>
                </tbody>
              </table>
            </div>
            {/**/}
          </div>
        )}
      </div>
    </app-pl-awccasino>
  );
};

export default ReportByBoCasino;
